/**
 * クリップボードへの書き込み。
 *
 * 閲覧専用の表は**フォーカスを持たない**ので `copy` イベントが来る保証が無く、
 * keydown から自前で書く必要がある。Clipboard API が無い / 権限が下りない環境では
 * `execCommand('copy')` に落として黙って諦める (コピーできない環境で例外を投げない)。
 */
export async function writeClipboardText(
  text: string,
  doc: Document,
): Promise<void> {
  const clipboard = doc.defaultView?.navigator.clipboard
  if (clipboard !== undefined) {
    try {
      await clipboard.writeText(text)
      return
    } catch {
      // 権限拒否 / 非セキュアコンテキスト → 下の fallback へ
    }
  }
  const area = doc.createElement('textarea')
  area.value = text
  area.setAttribute('readonly', 'true')
  // 画面外に置かず opacity:0 で重ねる (画面外だと select() でスクロールが飛ぶ)
  area.style.position = 'fixed'
  area.style.top = '0'
  area.style.left = '0'
  area.style.opacity = '0'
  doc.body.appendChild(area)
  try {
    area.select()
    if (typeof doc.execCommand === 'function') doc.execCommand('copy')
  } catch {
    // コピー不可の環境 (テスト環境など) では何もしない
  } finally {
    area.remove()
  }
}
